(() => {
  const sectionSelector = 'body.template-page-press section-highlight-carousel';
  const cloneAttribute = 'data-press-highlight-clone';
  const realIndexAttribute = 'data-press-highlight-real-index';
  const readyAttribute = 'data-press-highlight-loop-ready';
  const focusableSelector = 'a, button, input, select, textarea, [tabindex]';

  const makeClone = (slide, cloneType, realIndex) => {
    const clone = slide.cloneNode(true);
    clone.setAttribute(cloneAttribute, cloneType);
    clone.setAttribute(realIndexAttribute, realIndex);
    clone.setAttribute('aria-hidden', 'true');

    clone.querySelectorAll(focusableSelector).forEach((element) => {
      element.setAttribute('tabindex', '-1');
    });

    return clone;
  };

  const normalizeIfClone = (swiper, realSlideCount) => {
    if (!swiper || swiper.destroyed) return;

    const activeSlide = swiper.slides[swiper.activeIndex];
    const cloneType = activeSlide && activeSlide.getAttribute(cloneAttribute);
    const realIndex = activeSlide && Number(activeSlide.getAttribute(realIndexAttribute));

    if (!cloneType || Number.isNaN(realIndex)) return;

    const targetIndex = realSlideCount + realIndex;
    swiper.slideTo(targetIndex, 0, false);
    swiper.updateSlidesClasses();
  };

  const initSection = (section, attempts = 0) => {
    if (!section || section.getAttribute(readyAttribute) === 'true') return;

    const carousel = section.querySelector('[data-highlight-carousel]');
    const wrapper = section.querySelector('.swiper-wrapper');
    const existingSwiper = carousel && carousel.swiper;

    if (!carousel || !wrapper || !existingSwiper) {
      if (attempts < 12) {
        window.setTimeout(() => initSection(section, attempts + 1), 100);
      }

      return;
    }

    const Swiper = existingSwiper.constructor;
    const modules = existingSwiper.originalParams && existingSwiper.originalParams.modules;
    const previousButton = section.querySelector('[data-carousel-navigation-previous]');
    const nextButton = section.querySelector('[data-carousel-navigation-next]');

    existingSwiper.destroy(true, true);
    section.querySelectorAll(`[${cloneAttribute}]`).forEach((clone) => clone.remove());

    const realSlides = [...wrapper.querySelectorAll('.highlight-card.swiper-slide')];

    if (realSlides.length < 2) return;

    realSlides.forEach((slide, index) => {
      slide.setAttribute(realIndexAttribute, index);
      slide.removeAttribute('aria-hidden');
    });

    realSlides.forEach((slide, index) => {
      wrapper.insertBefore(makeClone(slide, 'before', index), realSlides[0]);
    });

    realSlides.forEach((slide, index) => {
      wrapper.appendChild(makeClone(slide, 'after', index));
    });

    const swiper = new Swiper(carousel, {
      modules,
      slidesPerView: 'auto',
      spaceBetween: 0,
      direction: 'horizontal',
      initialSlide: realSlides.length,
      loop: false,
      rewind: false,
      watchOverflow: false,
      navigation: {
        prevEl: previousButton,
        nextEl: nextButton
      }
    });

    swiper.on('transitionEnd', () => normalizeIfClone(swiper, realSlides.length));
    swiper.on('slideChange', () => {
      window.requestAnimationFrame(() => {
        if (!swiper.animating) normalizeIfClone(swiper, realSlides.length);
      });
    });

    section.setAttribute(readyAttribute, 'true');
    section.pressHighlightSwiper = swiper;
  };

  const initAll = () => {
    document.querySelectorAll(sectionSelector).forEach((section) => initSection(section));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  window.customElements.whenDefined('section-highlight-carousel').then(initAll);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target && event.target.matches('section-highlight-carousel')
      ? event.target
      : event.target && event.target.querySelector('section-highlight-carousel');

    initSection(section);
  });
})();
